import {
  CurrencyDisplay,
  LeftRightFlexedContainer,
  ModalSectionTitle,
} from "../../../../components";
import { chargeBearer } from "../../../../enums";
import { HookFormSelect, SubmitButton, TextInput } from "../../../../hook-form";
import { IAcceptAsPartialPaymentFormViewProps } from "./AcceptAsPartialPaymentForm";

export const View = ({
  isLoadingFormData,
  isFormEnabled,
  formDisabledReason,

  refundAmount,
  refundCurrency,
  destinationTransactionOrParent,

  errors,
  handleSubmit,
  register,
}: IAcceptAsPartialPaymentFormViewProps) => {
  return (
    <form
      onSubmit={handleSubmit}
      className="accept-as-partial--form bordered border-dashed b-r-5 pl-5 pr-5 pb-5"
    >
      <ModalSectionTitle
        key_id={
          <>
            Accept an incomplete payment as a partial payment. The customer can
            complete the payment later.
          </>
        }
        value={""}
      />
      <div className="bg-gray-2 mt-5 mb-5 pl-5 pr-5 pb-5 pt-5 b-r-5">
        <span className="text-danger">
          NOTE: This will be applied to the same payment/invoice the customer
          attempted to make payment to.
        </span>{" "}
        <br /> If you want to apply it to a different payment/invoice, use the
        <strong>"REDIRECT TO INVOICE"</strong> option for the same customer
      </div>

      <LeftRightFlexedContainer
        key_id="Amount To Accept"
        value={
          <CurrencyDisplay
            amount={refundAmount}
            currencyOrSymbol={refundCurrency}
          />
        }
      />

      {!destinationTransactionOrParent ? null : (
        <div className="bg-success">
          <LeftRightFlexedContainer
            key_id="Transaction Amount"
            value={
              <CurrencyDisplay
                amount={destinationTransactionOrParent.amount}
                currencyOrSymbol={refundCurrency}
              />
            }
          />

          <LeftRightFlexedContainer
            key_id="Transaction Amount Paid"
            value={
              <CurrencyDisplay
                amount={destinationTransactionOrParent.amount_paid}
                currencyOrSymbol={refundCurrency}
              />
            }
          />

          <LeftRightFlexedContainer
            key_id="Transaction Ref"
            value={destinationTransactionOrParent.tx_ref}
          />
        </div>
      )}

      <div className="flex-container flex-break--small">
        <div className="flex-box">
          <TextInput
            name="max_partial_payment_count"
            label="Max Partial Payments Count"
            infoIconText={`
                This determines the total number of partial payments the customer will be allowed to make in order to complete the transaction.`}
            infoIconPosition="bottom"
            type="number"
            register={register}
            errors={errors}
          />
        </div>

        <div className="flex-box ml-md-5">
          <HookFormSelect
            name="bearer"
            label="Charge Bearer"
            infoIconText={
              <>
                This determines who bears the app fees.
                <br />
                <strong>NOTE:</strong> that if it is set to customer, and the
                total amount of partial payments do not cover the fees, then the
                transaction may not settle as SUCCESSFUL, but PARTIAL. <br />
                Then the customer may have to pay extra in order to complete the
                transaction.
              </>
            }
            infoIconPosition="bottom"
            // showSkeleton={isLoadingFormData}
            selectItems={Object.keys(chargeBearer).map((bearerEntry) => ({
              text: `${bearerEntry}`,
              value: bearerEntry,
            }))}
            register={register}
            errors={errors}
          />
        </div>
      </div>

      <TextInput
        name="description"
        label="Description (Optional)"
        placeholder="e.g. Used to settle school fees payment for second child"
        infoIconText="This will help you in the future to recall why you performed this action."
        type="text"
        register={register}
        errors={errors}
      />

      {!formDisabledReason || formDisabledReason === "" ? null : (
        <div className="text-danger mt-5">{formDisabledReason}</div>
      )}

      <div className="flex-container submit-button--container">
        <SubmitButton
          // size="md"
          className="mt-5 flex-box"
          showChildrenWithLoadingIcon
          disabled={!isFormEnabled}
          title={isFormEnabled ? "" : formDisabledReason}
        >
          Accept As Partial Payment
        </SubmitButton>
      </div>
    </form>
  );
};
